import React from "react";
import { getFEWalletParams } from "./../../../../platform.pay.config";
import { formatSeconds } from "./../../../lib/utils";

import translate from "./../../../lib/translate/TranslateJs";



export default class WithdrawalSuccessTimer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            countdown: '60:00',
            times: '3600'
        };
        this.timeOuts = null
        this.feWalletParams = getFEWalletParams();
    }

    componentWillMount() {
        if (this.props.type && this.props.type == 'LB' && this.feWalletParams.languageType === "M3")
        this.setState({
            countdown: '30:00',
            times: '1800'
        })

    }
    componentDidMount() {
        this.setCountdown()
    }
    componentDidUpdate(prevProps, prevState) {

    }
    componentWillUnmount() {
        this.timeOuts && clearInterval(this.timeOuts);
        this.timeOuts = null
    }
    setCountdown = () => {
        this.timeOuts && clearInterval(this.timeOuts);
        this.timeOuts = null


        let time = this.state.times
        //5分钟后时间戳,防止app后台setInterval没有执行，
        let afterMinutes5 = (new Date()).getTime() + (time * 1000)

        let m, s, ms;
        this.timeOuts = setInterval(() => {
            time = parseInt((afterMinutes5 - (new Date().getTime())) / 1000)
            m = parseInt(time / 60).toString();
            s = time - m * 60;
            if (s < 10) {
                s = "0" + s.toString();
            }
            ms = m + ":" + s;
            if (m < 10) { ms = '0' + m.toString() + ":" + s; }
            this.setState({ countdown: ms });

            if (time <= 0) {
                this.timeOuts && clearInterval(this.timeOuts)
                this.timeOuts = null
            }
        }, 1000);
    }

    render() {

        const {
            RemainTime
        } = this.props;

        return <RemainTime
            remainingTime={this.state.countdown}
            goRecord={() => {this.feWalletParams.goRecord('withdraw',this.props.type)}}
            onCopy={() => {this.feWalletParams.toastTip.success(translate("复制成功")())}}
        />
    }
}